import { Dialog, DialogContent } from '@material-ui/core';
import React from 'react';

import {
  QuotationCoverage,
  RequestIndicatorTypes,
} from 'data-layer-cr/dist/models';

import { NetworkIndicator } from 'design-system';

import IndividualSection from '../IndividualSection';

type MakeActiveSectionProps = {
  /** Shared */
  productType: string;
  /** Configurable section props */
  selectedEndorsement: QuotationCoverage;
  updateEndorsement: (
    modifiedPackage: number,
    newCode: string,
    newValue: number,
  ) => void;
  updateEndorsementExemption: (
    modifiedPackage: number,
    addExemptionCoverage: boolean,
    packageSelected: string,
  ) => void;
  updateCustomerProfile: (
    modifiedPackage: number,
    newCode: string,
    newValue: number,
    packageSelected: string,
  ) => void;
  onChangeCoverageLimit: (
    modifiedPackage: number,
    modifiedCoverage: QuotationCoverage[],
    shouldUpdate: boolean,
    packageSelected: string,
  ) => void;
  onChangeDeductible: (
    modifiedPackage: number,
    deductibleOption: number,
  ) => void;
};
export function makeActiveSection({
  productType,
  selectedEndorsement,
  updateEndorsement,
  updateEndorsementExemption,
  updateCustomerProfile,
  onChangeCoverageLimit,
  onChangeDeductible,
}: MakeActiveSectionProps): React.ReactNode {
  return (
    <IndividualSection
      data-testid="individual-section"
      productId={productType}
      selectedEndorsement={selectedEndorsement}
      onEndorsementUpdated={updateEndorsement}
      onEndorsementUpdatedExemption={updateEndorsementExemption}
      onCustomerProfileUpdated={updateCustomerProfile}
      onChangeCoverageLimit={onChangeCoverageLimit}
      onChangeDeductible={onChangeDeductible}
    />
  );
}

export function makeCreateNetworkDialogue(
  creatingQuotationState: RequestIndicatorTypes,
): React.ReactNode {
  return (
    <Dialog
      data-testid="create-network-dialogue"
      open={creatingQuotationState === 'requesting'}
    >
      <DialogContent>
        <NetworkIndicator requesting message="Creando cotización..." />
      </DialogContent>
    </Dialog>
  );
}

export function makeCoverageNetworkDialogue(
  requestingCoverageState: RequestIndicatorTypes,
  requestingConfigState: RequestIndicatorTypes,
): React.ReactNode {
  return (
    <Dialog
      data-testid="coverage-request-dialogue"
      open={
        requestingCoverageState === 'requesting' ||
        requestingConfigState === 'requesting'
      }
    >
      <DialogContent>
        <NetworkIndicator
          requesting
          message="Obteniendo datos de coberturas..."
        />
      </DialogContent>
    </Dialog>
  );
}
